var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLongTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8123 24.9227C23.8123 24.9227 23.8123 15.3319 23.8209 11.8166C23.8209 11.4379 23.9806 11.0776 24.2616 10.8205C24.5441 10.5647 24.9207 10.4376 25.3015 10.4701C32.4223 11.1469 38.3677 16.6628 38.372 24.9565V24.9608V24.9664C38.3677 33.8296 31.5779 39.5306 23.8194 39.5349H23.8152H23.8123C16.4961 39.5306 10.0357 34.4569 9.30678 26.4471C9.2754 26.0628 9.40807 25.6814 9.67196 25.3974C9.93728 25.112 10.3096 24.9509 10.7004 24.9509L23.8123 24.9227Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9239 37.6736C18.0707 44.8205 29.5082 44.8895 36.4706 37.9271C43.433 30.9647 43.3639 19.5273 36.2171 12.3805C30.293 6.45639 21.4071 5.39244 14.5805 9.17664C13.6859 9.67249 12.5588 9.34932 12.063 8.45481C11.5671 7.56031 11.8903 6.43319 12.7848 5.93734C21.0527 1.35417 31.7405 2.66599 38.836 9.76154C47.3846 18.3101 47.5425 32.093 39.0895 40.546C30.6365 48.999 16.8536 48.8411 8.30501 40.2926C1.17595 33.1635 -0.114743 22.408 4.54631 14.124C5.04783 13.2327 6.17697 12.9167 7.06832 13.4182C7.95966 13.9197 8.27567 15.0489 7.77415 15.9402C3.92602 22.7794 4.97172 31.7215 10.9239 37.6736Z",
    fill: "#4C4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLongTime);
export default __webpack_public_path__ + "static/media/ic_long_time.65ce9740f3d662c7374a96ffd1874f16.svg";
export { ForwardRef as ReactComponent };